import React from 'react';
import { ArrowForward } from '@yme/assets/icons';
import { Button, SIZE_36, GHOST_VARIANT, ICON_ONLY } from '@yme/atoms/button';
import { ArrowNavStyled } from './styled';
export function ArrowNav(props) {
    const { activeItem, onClickPrevItem, onClickNextItem, isRightToLeft, indexOfCount, titlePrev, titleNext, isDarkMode, arrowNavSize = SIZE_36, isDisabledNextBtn = false, } = props;
    return (React.createElement(ArrowNavStyled, null,
        React.createElement(Button, { isDarkMode: isDarkMode, buttonVariant: GHOST_VARIANT, hasIconButton: ICON_ONLY, iconComponent: ArrowForward, iconRotate: isRightToLeft ? 0 : -180, size: arrowNavSize, onClick: onClickPrevItem, disabled: activeItem === 0, ...(titleNext && {
                title: titlePrev,
            }) }),
        React.createElement(Button, { isDarkMode: isDarkMode, buttonVariant: GHOST_VARIANT, hasIconButton: ICON_ONLY, iconComponent: ArrowForward, iconRotate: isRightToLeft ? -180 : 0, size: arrowNavSize, onClick: onClickNextItem, disabled: activeItem === indexOfCount || isDisabledNextBtn, title: titleNext, ...(titleNext && {
                title: titleNext,
            }) })));
}
ArrowNav.displayName = 'ArrowNav_Component';
